import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TeacherSalaryComponent = () => {
  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [salaryMonth, setSalaryMonth] = useState('');
  const [basicSalary, setBasicSalary] = useState('');
  const [allowances, setAllowances] = useState('');
  const [deductions, setDeductions] = useState('');
  const [netSalary, setNetSalary] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('Pending');
  const [remarks, setRemarks] = useState('');

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeachers`)
      .then(response => {
        setTeachers(response.data);
      })
      .catch(error => {
        console.error('There was an error fetching the teacher data!', error);
      });
  }, []);

  const calculateNetSalary = () => {
    const net = parseFloat(basicSalary) + parseFloat(allowances) - parseFloat(deductions);
    setNetSalary(net.toFixed(1));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here, e.g., POST API call to save salary data
    console.log({
      teacherId: selectedTeacher,
      salaryMonth,
      basicSalary,
      allowances,
      deductions,
      netSalary,
      paymentStatus,
      remarks
    });
  };

  return (
    <div className="max-w-full p-6 bg-white shadow-lg rounded-lg">
   
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">Select Teacher</label>
          <select
            value={selectedTeacher}
            onChange={(e) => setSelectedTeacher(e.target.value)}
            className="block w-full p-3 border rounded-lg focus:outline-none focus:border-blue-500"
            required
          >
            <option value="">Select a teacher</option>
            {teachers.map((teacher) => (
              <option key={teacher._id} value={teacher._id}>
                {teacher.firstName} {teacher.lastName}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">Salary Month</label>
          <input
            type="month"
            value={salaryMonth}
            onChange={(e) => setSalaryMonth(e.target.value)}
            className="block w-full p-3 border rounded-lg focus:outline-none focus:border-blue-500"
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-gray-600 font-medium mb-2">Basic Salary</label>
            <input
              type="number"
              value={basicSalary}
              onChange={(e) => setBasicSalary(e.target.value)}
              onBlur={calculateNetSalary}
              className="block w-full p-3 border rounded-lg focus:outline-none focus:border-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-gray-600 font-medium mb-2">Allowances</label>
            <input
              type="number"
              value={allowances}
              onChange={(e) => setAllowances(e.target.value)}
              onBlur={calculateNetSalary}
              className="block w-full p-3 border rounded-lg focus:outline-none focus:border-blue-500"
            />
          </div>

          <div>
            <label className="block text-gray-600 font-medium mb-2">Deductions</label>
            <input
              type="number"
              value={deductions}
              onChange={(e) => setDeductions(e.target.value)}
              onBlur={calculateNetSalary}
              className="block w-full p-3 border rounded-lg focus:outline-none focus:border-blue-500"
            />
          </div>

          <div>
            <label className="block text-gray-600 font-medium mb-2">Net Salary</label>
            <input
              type="text"
              value={netSalary}
              readOnly
              className="block w-full p-3 border rounded-lg bg-gray-100 cursor-not-allowed"
            />
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">Payment Status</label>
          <select
            value={paymentStatus}
            onChange={(e) => setPaymentStatus(e.target.value)}
            className="block w-full p-3 border rounded-lg focus:outline-none focus:border-blue-500"
          >
            <option value="Pending">Pending</option>
            <option value="Paid">Paid</option>
            <option value="Partially Paid">Partially Paid</option>
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">Remarks</label>
          <textarea
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            className="block w-full p-3 border rounded-lg focus:outline-none focus:border-blue-500"
            rows="3"
          ></textarea>
        </div>

        <button
          type="submit"
          className="w-full py-3 px-6 bg-blue-800 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          Submit Salary
        </button>
      </form>
    </div>
  );
};

export default TeacherSalaryComponent;
